import React from 'react';
import { FirstStep, SecondStep } from '@/components/template/CreateTemplate';
import { useTemplateStore } from '@/stores/templateStore';
import { TemplateContext } from '@/contexts/templateContext';
import CreationPage from '@/components/commos/CreationPage';
import { Button } from '@ab-inbev-maz/compass';

const items = [
  {
    id: 'image',
    title: 'Carga de imagen de Template',
    Component: () => <FirstStep />
  },
  {
    id: 'form',
    title: 'Información general del Template',
    Component: () => <SecondStep />
  }
]

const TemplatePage: React.FC = () => {
  const saveSingleTemplate = useTemplateStore(state => state.saveSingleTemplate);

  const saveButton = (isDisabled: boolean, isFetching: boolean) => (
    <Button
      key="save-button"
      label="Guardar template"
      rightIcon="functionalities/save"
      variant="primary"
      disabled={isDisabled || isFetching}
      type="submit"
      form="template-general-info"
    />
  );

  const pageConfig = {
    title: "Creación de Templates",
    description: "Crea y personaliza templates a tu medida de forma fácil y rápida desde esta sección.",
    tablePath: "/templates/table"
  };

  const modalConfig = {
    title: '¿Confirmar la creación de nuevo Template?',
    message: 'Estás a punto de crear un nuevo Template. Una vez guardado, quedará almacenado en la Listado de Templates.',
    successText: 'Template guardado exitosamente',
    successMessage: (fileName?: string) => `El Template "${fileName}" ha sido guardado en la librería`,
    errorText: 'Error al guardar Template'
  };

  return (
    <CreationPage
      pageConfig={pageConfig}
      saveButton={saveButton}
      items={items}
      saveFunction={saveSingleTemplate}
      ContextProvider={TemplateContext}
      modalConfig={modalConfig}
    />
  );
};

export default TemplatePage;
